// extracted by mini-css-extract-plugin
module.exports = {"collapsible":"_1Tf9S","animating":"_3-ebs","open":"_3Ret3","fullyOpen":"_3ZyKp"};